module.exports = __webpack_public_path__ + "static/platform-emulation-b9fd0a3ebe150d273539940fbd9e620d.mp4";